import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"
import isValidHardGoldOnPCIEdgeTerminal from "../../../../service/visibleValidator/isValidHardGoldOnPCIEdgeTerminal"

import hardGoldOnPCIEdgeTerminal from "./hardGoldOnPCIEdgeTerminal.png"

const 端子部のみ電解金めっき = ({ values, handlers }: OneClickFieldProps) => {
  const { hardGoldOnPCIEdgeTerminal: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField
      isShow={shouldShow}
      legend={"端子部のみ\n電解金めっき"}
      src={hardGoldOnPCIEdgeTerminal}
      helpURL={HELP_LINKS.端子部のみ電解金めっき}
    >
      <RadioGroup
        name={FIELD_NAMES.端子部のみ電解金めっき}
        selectedValue={values.hardGoldOnPCIEdgeTerminal}
        onChange={handlers.radio}
        shouldRender={(value) => isValidHardGoldOnPCIEdgeTerminal(values, value)}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.端子部のみ電解金めっき.する.value}>する</Radio>
          <Radio value={ESTIMATE_CONSTANT.端子部のみ電解金めっき.しない.value}>しない</Radio>
        </OneClickFieldStack>
      </RadioGroup>
    </OneClickField>
  )
}

export default 端子部のみ電解金めっき
